import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DndDropEvent } from 'ngx-drag-drop';
import { MAX_SORTABLE_VALUES } from '../sort-modal.helpers';

type TItems = unknown[];

export interface DragEndData {
  event: DragEvent;
  item: unknown;
}

@Component({
  selector: 'mode-sort-modal-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortModalListComponent implements OnChanges {
  @Input() items!: TItems;
  @Input() formatter!: (name: any) => string | null;

  @Output() orderChanged = new EventEmitter<TItems>();
  @ViewChild(CdkVirtualScrollViewport) scrollContainer!: CdkVirtualScrollViewport;

  orderedItems: TItems = [];
  itemIndex = 0;
  loading = true;
  maxSortableValues = MAX_SORTABLE_VALUES;

  tooltipContent = 'Only the first 200 manually sorted items will persist.';
  tooltipInteractivity = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items?.currentValue) {
      this.orderedItems = [...this.items];
      if (this.items.length > 0) {
        this.loading = false;
      }
    }
  }

  shiftItem(from: number, to: number) {
    const item = this.orderedItems.splice(from, 1)[0];
    this.orderedItems.splice(to, 0, item);
    this.orderedItems = [...this.orderedItems];
  }

  emitChanges() {
    this.orderChanged.emit(this.orderedItems);
  }

  moveToTop(item: unknown) {
    const index = this.orderedItems.indexOf(item);
    this.shiftItem(index, 0);
    this.scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
    this.emitChanges();
  }

  onDragStart($event: DndDropEvent, item: unknown) {
    this.itemIndex = this.orderedItems.indexOf(item);
  }

  onDrop($event: DndDropEvent, isContainer: boolean) {
    const index = $event.index as number | 0;
    const moveToIndex = isContainer ? this.items.length - 1 : index < this.itemIndex ? index : index - 1;
    this.shiftItem(this.itemIndex, moveToIndex);
    this.emitChanges();
  }

  resetList(items: ReadonlyArray<any>) {
    this.orderedItems = [...items];
    this.cdr.markForCheck();
  }
}
